import { campaign, logo, description, dois, links, legends, defaultCamera, instrumentLayers } from "./components"

const lee_campaign = {
  title: `${campaign.toUpperCase()} Field Campaign`,
  logo: logo,
  description: description,
  links: links,
  dois: dois,
  legends: legends,
  defaultCamera: defaultCamera,
  layers: instrumentLayers,
}

export default lee_campaign
